module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "daydish"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "offer-left"
  }, [_c('span', {
    staticClass: "section-suptitle"
  }, [_vm._v(_vm._s(_vm.dayDish.date))]), _vm._v(" "), _c('h2', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.dayDish.title))]), _vm._v(" "), _vm._l((_vm.dayDish.menu), function(dish, index) {
    return _c('div', {
      staticClass: "offer-item daydish"
    }, [_c('div', [_c('p', [_vm._v(_vm._s(dish.day))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(dish.dish))])])])
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "daydish info"
  }, [_vm._v("* " + _vm._s(_vm.dayDish.info))])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), (!_vm.isMobile()) ? _c('section', {
    staticClass: "parallax-window",
    attrs: {
      "id": "deco",
      "data-background": "static/img/bg/outdor.jpg"
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "offer-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/img/bg/meals.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/menu"
    }
  }, [_vm._v("\n              Nos mets\n              "), _c('span', [_vm._v("à emporter")])]), _vm._v(" "), _c('a', {
    staticClass: "uber",
    attrs: {
      "href": "https://www.ubereats.com/ch/store/la-pizzetta/Snc5SHZ5SJ2AUr5MTHHiKQ",
      "target": "_blank"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-205da860"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 14
// module chunks = 0